import { fg } from '@atlassian/jira-feature-gating';
import { createRouterSelector } from '@atlassian/react-resource-router';
import { isIsolatedCloud } from '@atlassian/atl-context';

export const useUrl = createRouterSelector(({ match }) => match.url);

export const useHideAssetsReportsInIsolatedCloud = () => {
	const url = useUrl();
	const isIsolatedCloudEnv = isIsolatedCloud();
	const isReportsUrl = url.startsWith('/jira/assets/reports');

	if (isReportsUrl && isIsolatedCloudEnv && fg('hide-reports-ic-env')) {
		return true;
	}

	return false;
};
